import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showToast } from '@/services/toast-service';
import { usePopUpConfirmation } from '@/features/shared/pop-up-confirmation/hooks';
import { archiveBroadcastMessage } from '@/services/coloc-api/admin';

export const useArchiveBroadcastMessage = () => {
  const queryClient = useQueryClient();
  const { openPopUpConfirmation } = usePopUpConfirmation();

  const mutation = useMutation({
    mutationKey: ['archiveBroadcastMessage'],
    mutationFn: (id: number) => archiveBroadcastMessage(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['broadcast-messages']);
      openPopUpConfirmation({
        type: 'feedback',
        title: 'Message archived',
        confirmLabel: 'Done',
      });
    },
    onError: () => {
      showToast.error({
        title: 'Failed to archive message',
        text: 'Please try again.',
      });
    },
  });

  return {
    archiveMessage: mutation.mutate,
    isLoading: mutation.isLoading,
    error: mutation.error,
  };
};
